import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  '@keyframes rotater': {
    from: { transform: 'rotate(0)', transformOrigin: 'center center' },
    to: { transform: 'rotate(360deg)', transformOrigin: 'center center' }
  },
  modal: {
    [theme.breakpoints.down('sm')]: {
      overflowY: 'auto'
    }
  },
  deletePaper: {
    backgroundColor: theme.palette.background.default,
    margin: 'auto',
    width: '60%',
    minWidth: 500,
    padding: '15px 10px',
    marginTop: '15vh',
    zIndex: 1,
    outline: 'none',
    position: 'relative',
    borderRadius: 16,
    [theme.breakpoints.down('xs')]: {
      width: '90%',
      minWidth: 'unset',
      marginTop: '10vh',
      marginBottom: '10vh'
    }
  },

  deleteButton: {
    // backgroundColor: 'red',
    // color: 'white',
    marginRight: 8,
    marginTop: 18
  },
  buttonsContainer: {
    display: 'flex',
    justifyContent: 'flex-end'
  },
  copyIconButton: {
    position: 'absolute',
    top: -10,
    right: '12%',
    '& svg': {
      fontSize: 20
    }
  },

  root: {
    width: '100%',
    backgroundColor: theme.palette.background.default,
    padding: '10px 20px',
    borderRadius: '10px 0 10px 10px',
    height: 300,
    overflow: 'auto',
    overflowX: 'hidden',
    [theme.breakpoints.down('sm')]: { padding: '10px 3px' }
  },
  tableHeaderForModal: {
    width: '100%',
    display: 'grid',
    gridTemplateColumns: '2fr 3fr 2fr',
    gridGap: 20,
    color: 'gray',
    alignItems: 'center',
    // padding: '0 0 0 12px'
    marginBottom: 4,
    marginTop: 4,
    backgroundColor: 'transparent'
  },
  tableHeader: { textAlign: 'left' },
  tableRowRoot: {
    display: 'grid',
    gridTemplateColumns: '1fr',
    height: 50,
    marginBottom: 4,
    alignItems: 'center',
    borderRadius: 20,
    cursor: 'pointer',
    // paddingLeft: 12,
    transition: 'background-color 0.3s ease-in-out',
    width: '100%',
    textAlign: 'unset'
  },
  tableRowForModal: {
    display: 'grid',
    gridTemplateColumns: '2fr 3fr 2fr',
    gridGap: 20,
    height: 60,
    marginBottom: 4,
    alignItems: 'center',
    // backgroundColor: theme.palette.background.paper,
    cursor: 'pointer',
    // paddingLeft: 12,
    // transition: 'background-color 0.3s ease-in-out',
    width: '100%',
    textAlign: 'unset',
    color: `${theme.palette.text.secondary} !important`
  },
  tableItem: {
    // width: 120,
    color: 'inherit',
    textAlign: 'left',
    wordWrap: 'break-word',
    whiteSpace: 'normal',
    wordBreak: 'break-word'
  },

  nameCell: {
    display: 'flex'
  },
  rotate: {
    transformOrigin: 'center center',
    animationName: '$rotater',
    animationDuration: '1s',
    animationIterationCount: 'infinite',
    animationFillMode: 'both',
    animationTimingFunction: 'linear'
  },
  iconContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: '#757575'
  },
  menuItem: {
    width: '100%'
  }
}))

export default useStyles
